import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';

var AppCheckbox = /*#__PURE__*/function (_Vue) {
  _inherits(AppCheckbox, _Vue);

  var _super = _createSuper(AppCheckbox);

  function AppCheckbox() {
    _classCallCheck(this, AppCheckbox);

    return _super.apply(this, arguments);
  }

  _createClass(AppCheckbox, [{
    key: "switchValue",
    value: function switchValue() {
      return !this.value;
    }
  }]);

  return AppCheckbox;
}(Vue);

__decorate([Prop()], AppCheckbox.prototype, "value", void 0);

__decorate([Prop({
  default: false
})], AppCheckbox.prototype, "disabled", void 0);

__decorate([Prop()], AppCheckbox.prototype, "label", void 0);

__decorate([Emit('input')], AppCheckbox.prototype, "switchValue", null);

AppCheckbox = __decorate([Component({})], AppCheckbox);
export default AppCheckbox;